import { AusActions } from "@aus/Store/AusState";
import BypassAddressValidationState from "@aus/Store/Pages/CheckoutShipping/BypassAddressValidationState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<BypassAddressValidationState, DispatchProp<AusActions>>;

export const UpdateState: HandlerType = props => {
    props.dispatch({
        type: "Pages/CheckoutShipping/UpdateByPassAddressValidation",
        parameter: props.parameter,
    });
};

export const chain = [UpdateState];

const UpdateByPassAddressValidation = createHandlerChainRunner(chain, "UpdateByPassAddressValidation");
export default UpdateByPassAddressValidation;
